import * as T from '^/types';

export default {
  title: {
    [T.Language.KO_KR]: '관련 작업만 보기',
    [T.Language.EN_US]: 'Only show issues assigned to me',
  },
};
